module.exports = __webpack_public_path__ + "img/star-empty-20x20.a8feee1c.svg";